export default "__VITE_ASSET__DbuqgVkq__"